var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFieldwellsAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.805,
    height: 13.805,
    viewBox: "0 0 13.805 13.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Report",
    "data-name": "New Report",
    transform: "translate(-404 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notes",
    transform: "translate(417.804 224.805) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Report-2",
    "data-name": "New Report",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52930",
    "data-name": "Path 52930",
    d: "M12.148,0H1.657A1.657,1.657,0,0,0,0,1.657V12.148A1.657,1.657,0,0,0,1.657,13.8H12.148A1.657,1.657,0,0,0,13.8,12.148V1.657A1.657,1.657,0,0,0,12.148,0ZM12.7,12.148a.552.552,0,0,1-.552.552H1.657a.552.552,0,0,1-.552-.552V1.657A.552.552,0,0,1,1.657,1.1H12.148a.552.552,0,0,1,.552.552Z",
    transform: "translate(0 0)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52931",
    "data-name": "Path 52931",
    d: "M6.074,2.761H3.865V.552a.552.552,0,1,0-1.1,0V2.761H.552a.552.552,0,1,0,0,1.1H2.761V6.074a.552.552,0,1,0,1.1,0V3.865H6.074a.552.552,0,1,0,0-1.1Z",
    transform: "translate(3.59 3.589)",
    fill: "#f45e29"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFieldwellsAdd);
export default __webpack_public_path__ + "static/media/icon-fieldwells-add.6de33804.svg";
export { ForwardRef as ReactComponent };